import { Directive, ElementRef, Input } from "@angular/core";
import { HioShareBasicService } from "./hio-share-basic.service";

@Directive({
    selector: "input",
    standalone: true
})
export class InputDirective {
  @Input() selectOnFocus = true;

  constructor(element: ElementRef, shareBasicService: HioShareBasicService) {
    let elem = (element.nativeElement as HTMLInputElement);
    setTimeout(() => {
      elem.autocomplete = 'off';
      elem.setAttribute('autocomplete', 'off');
      elem.setAttribute('autocapitalize', 'off');
      elem.setAttribute('autocorrect', 'off');
      if (elem.type == 'date' && elem.max == '')
        elem.max = '9999-12-31';

      if (elem.type == 'datetime-local' && elem.max == '')
        elem.max = '9999-12-31T23:59:59';

      if (elem.type == 'text' && elem.maxLength == -1)
        elem.maxLength = 255;

    }, 100);
    elem.addEventListener('focus', () => {
      if (this.selectOnFocus && shareBasicService.onFocusInputSelectValue)
        elem.select();
    });
  }
}
